export default [
    {
        name: 'BqAll',
        path: 'BqAll',
        component: () => import('@/pages/BigData/CopyrightModule/BanquanRegist/BqAll'),
        meta: { title: '全部', requiresAuth: true },
        props(route) {
            return { id: route.query.id }
        },
    },
    {
        name: 'BToBeDeclared',
        path: 'BToBeDeclared',
        component: () => import('@/pages/BigData/CopyrightModule/BanquanRegist/BToBeDeclared'),
        meta: { title: '待申报', requiresAuth: true },
        props(route) {
            return { id: route.query.id }
        },
    },         
    {
        name: 'BqDeclaring',
        path: 'BqDeclaring',
        component: () => import('@/pages/BigData/CopyrightModule/BanquanRegist/BqDeclaring'),
        meta: { title: '申报中', requiresAuth: true },
        props(route) {
            return { id: route.query.id }
        },
    },
    {
        name: 'BqDeclaredRegistering',
        path: 'BqDeclaredRegistering',
        component: () => import('@/pages/BigData/CopyrightModule/BanquanRegist/BqDeclaredRegistering'),
        meta: { title: '已申报-登记中', requiresAuth: true },
        props(route) {
            return { id: route.query.id }
        },
    },
    {
        name: 'BqRegistered',
        path: 'BqRegistered',
        component: () => import('@/pages/BigData/CopyrightModule/BanquanRegist/BqRegistered'),
        meta: { title: '已登记', requiresAuth: true },
        props(route) {
            return { id: route.query.id }
        },
    },
    {
        name: 'BqVoided',
        path: 'BqVoided',
        component: () => import('@/pages/BigData/CopyrightModule/BanquanRegist/BqVoided'),
        meta: { title: '已作废', requiresAuth: true },
        props(route) {
            return { id: route.query.id }
        },
    },
    {
        name: 'BanquanRegistDetails',
        path: 'BanquanRegistDetails',
        redirect:{name:'Sqcailiao'},
        component: () => import('@/pages/BigData/CopyrightModule/BanquanRegistDetails'),
        meta: { title: '详情', requiresAuth: true },
        props(route) {
            return { id: route.query.id }
        },
        children:[
            {
                name: 'Sqcailiao',
                path: 'Sqcailiao',
                component: () => import('@/pages/BigData/CopyrightModule/BanquanRegistDetails/Sqcailiao'),
                meta: { title: '申报材料', requiresAuth: true },
                props(route) {
                    return { id: route.query.id }
                },  
            },
            {
                name: 'QRcailiao',
                path: 'QRcailiao',
                component: () => import('@/pages/BigData/CopyrightModule/BanquanRegistDetails/QRcailiao'),
                meta: { title: '需确认的材料', requiresAuth: true },
                props(route) {
                    return { id: route.query.id }
                },  
            },
            {
                name: 'TZweishu',
                path: 'TZweishu',
                component: () => import('@/pages/BigData/CopyrightModule/BanquanRegistDetails/TZweishu'),
                meta: { title: '确认材料', requiresAuth: true },
                props(route) {
                    return { id: route.query.id }
                },  
            },
         
        ]
    },
]
